import React, { useState } from 'react';
import Nav from './nav';

export default function SideBar({ fullMenu }) {
  const [headerOpen, toggleHeader] = useState(false);
  return (
    <Nav onMenuToggle={() => toggleHeader(!headerOpen)} />
  );
}
